import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { CMService } from "../../providers/cm-service/cm-service";
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { UserService } from "../../providers/session-service/user-service";
import { Http } from "@angular/http";

@Component({
    selector: 'page-post-details',
    templateUrl: 'post-details.html',
})
export class PostDetailsPage {

    private postId: number;
    private post: any;
    private showSpinner: any;
    private newCommentData: FormGroup;
    private sessionType: string;

    constructor(public navParams: NavParams, public cmService: CMService, private formBuilder: FormBuilder, private userService: UserService, public http: Http) {
        this.sessionType = userService.getSessionType();
        this.showSpinner = true;
        this.postId = this.navParams.get('postId');
        this.post = {};
        this.post.comments = [];

        this.createForm();
    }

    createForm() {
        this.newCommentData = this.formBuilder.group({
            post_id: [this.postId],
            name: [this.sessionType !== 'guest' ? this.userService.getUser().name : '', Validators.required],
            email: [this.sessionType !== 'guest' ? this.userService.getUser().email : '', Validators.email],
            content: ["", Validators.required],
        });
    }

    ionViewDidLoad() {
        this.loadPostDetails();
    }

    loadPostDetails() {
        this.cmService.load('https://public-api.wordpress.com/wp/v2/sites/nbbasketball.home.blog/posts/' + this.postId).then((result) => {
            this.post.image = result.jetpack_featured_media_url;
            this.post.title = result.title.rendered;
            this.post.content = result.content.rendered;
        }).then(() => {
            this.showSpinner = false;
        });

        this.cmService.load('https://public-api.wordpress.com/wp/v2/sites/nbbasketball.home.blog/comments?post=' + this.postId).then((result) => {
            for (let i = 0; i < result.length; i++) {
                this.post.comments = result;
            }
        }).then(() => {
            this.showSpinner = false;
        });
    }

    submitComment() {
        let data = {
            author_email: this.newCommentData.value.email,
            author_name: this.newCommentData.value.name,
            content: this.newCommentData.value.content,
            post: this.newCommentData.value.post_id
        }
        this.cmService.submitComment('https://public-api.wordpress.com/wp/v2/sites/nbbasketball.home.blog/comments', data).then(() => {
            this.userService.createToast('Το σχόλιο σας υποβλήθηκε με επιτυχία');
            this.createForm();
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/post-details/post-details.ts